'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_DocumentTemplate(name, template) {
  this.Y0 = null;
  this.Ft = null;
  this.Y0 = name;
  this.Ft = template;
}
export { $c_Lapp_data_DocumentTemplate as $c_Lapp_data_DocumentTemplate };
$p = $c_Lapp_data_DocumentTemplate.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_DocumentTemplate;
/** @constructor */
function $h_Lapp_data_DocumentTemplate() {
}
export { $h_Lapp_data_DocumentTemplate as $h_Lapp_data_DocumentTemplate };
$h_Lapp_data_DocumentTemplate.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_DocumentTemplate)) {
    if ((this.Y0 === x$0.Y0)) {
      var x = this.Ft;
      var x$2 = x$0.Ft;
      return ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "DocumentTemplate";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Y0;
  }
  if ((n === 1)) {
    return this.Ft;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "name";
  }
  if ((n === 1)) {
    return "template";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_data_DocumentTemplate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jo)));
}
export { $isArrayOf_Lapp_data_DocumentTemplate as $isArrayOf_Lapp_data_DocumentTemplate };
var $d_Lapp_data_DocumentTemplate = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_DocumentTemplate, "app.data.DocumentTemplate", ({
  jo: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_DocumentTemplate as $d_Lapp_data_DocumentTemplate };
//# sourceMappingURL=app.data.-Document-Template.js.map
